import React from 'react';
import { Code2, Database, Globe, Shield, Cpu, Cloud, Smartphone, LineChart } from 'lucide-react';

const technologies = [
  {
    category: 'Frontend',
    icon: Globe,
    items: ['React', 'Next.js', 'Vue', 'Angular']
  },
  {
    category: 'Backend',
    icon: Code2,
    items: ['Node.js', 'Python', 'Java', 'Go']
  },
  {
    category: 'Database',
    icon: Database,
    items: ['PostgreSQL', 'MongoDB', 'Redis', 'Elasticsearch']
  },
  {
    category: 'Security',
    icon: Shield,
    items: ['OAuth', 'JWT', 'SSL', 'WAF']
  },
  {
    category: 'AI/ML',
    icon: Cpu,
    items: ['TensorFlow', 'PyTorch', 'OpenAI', 'Scikit-learn']
  },
  {
    category: 'Cloud',
    icon: Cloud,
    items: ['AWS', 'Azure', 'GCP', 'Vercel']
  },
  {
    category: 'Mobile',
    icon: Smartphone,
    items: ['React Native', 'Flutter', 'iOS', 'Android']
  },
  {
    category: 'Analytics',
    icon: LineChart,
    items: ['Google Analytics', 'Mixpanel', 'Segment', 'Amplitude']
  }
];

export default function TechStack() {
  return (
    <section className="py-20 bg-gray-50 dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl">
            Our Technology Stack
          </h2>
          <p className="mt-4 text-xl text-gray-600 dark:text-gray-300">
            We use cutting-edge technologies to build scalable, secure, and efficient solutions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {technologies.map((tech) => {
            const Icon = tech.icon;
            return (
              <div
                key={tech.category}
                className="bg-white dark:bg-gray-900 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow"
              >
                <div className="flex items-center mb-4">
                  <div className="p-2 bg-purple-100 dark:bg-purple-900 rounded-lg">
                    <Icon className="w-6 h-6 text-purple-600 dark:text-purple-400" />
                  </div>
                  <h3 className="ml-3 text-lg font-semibold text-gray-900 dark:text-white">
                    {tech.category}
                  </h3>
                </div>
                <ul className="space-y-2">
                  {tech.items.map((item) => (
                    <li
                      key={item}
                      className="text-gray-600 dark:text-gray-300 flex items-center"
                    >
                      <span className="h-1.5 w-1.5 bg-purple-600 rounded-full mr-2"></span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}